module.exports = __webpack_public_path__ + "static/media/GalleryImage07.8037bfac.jpg";